import { Button, Heading, ModalContent, Text } from 'components';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

interface Props {
  isInvoice: boolean;
  isPickupInStore: boolean;
  closeModal: () => void;
  isAdmin: boolean;
  isSubmitting: boolean;
  submitForm: () => void;
}

export function ConfirmAttendanceModal({
  isInvoice,
  isPickupInStore,
  closeModal,
  isAdmin,
  isSubmitting,
  submitForm,
}: Props) {
  return (
    <ModalContent handleClose={closeModal}>
      <S.ModalContentWrapper>
        <S.ModalContent>
          <Heading as="h3" weight={FontWeight.bold} size={FontSize.font16}>
            Emitir {isInvoice ? 'Nota' : 'Cupom'} Fiscal?
          </Heading>

          {isPickupInStore ? (
            <Text size={FontSize.font12}>
              Ao confirmar a emissão o cliente será comunicado automaticamente
              que poderá retirar o produto em sua loja.
            </Text>
          ) : (
            <Text size={FontSize.font12}>
              Ao confirmar acionaremos a transportadora automaticamente após a
              conclusão da emissão.
            </Text>
          )}
        </S.ModalContent>

        <S.ModalButtonsWrapper>
          <Button
            type="button"
            variant="outline-secondary"
            onClick={closeModal}
            disabled={isAdmin || isSubmitting}
          >
            Cancelar
          </Button>

          <Button
            type="button"
            variant="danger"
            full
            onClick={submitForm}
            disabled={isAdmin}
            isLoading={isSubmitting}
          >
            Emitir e{' '}
            {isPickupInStore ? 'comunicar cliente' : 'acionar transportadora'}
          </Button>
        </S.ModalButtonsWrapper>
      </S.ModalContentWrapper>
    </ModalContent>
  );
}
